<template>
  <div>
    <h2>{{ title }}</h2>
    <loading :active.sync="isLoading" :is-full-page="true"></loading>
    <template>
      <v-system-bar class="branch-data">
        <v-spacer></v-spacer>
        <div v-on:keypress.enter.prevent="getMembershipRateTable(1)">
          <input-search
            :model="search" @update="searchInput"/>
        </div>
        <circle-button
          v-if="permissionMembershipRate && permissionMembershipRate.permission_id === permission.readWrite"
          @click.native="createMembershipRate" />
      </v-system-bar>
    </template>
    <template>
      <v-simple-table class="branch-data">
        <template v-slot:default>
          <thead>
            <tr>
              <th class="text-center" v-for="header in headers" :key="header.id">
                {{ header.text }}
                <template v-if="header.icon">
                  <a @click="sortDataTable">
                    <v-icon class="fas fa-caret-down"
                            v-if="sort_order == 'desc'"
                            style="font-size: 12px"></v-icon>
                    <v-icon class="fas fa-caret-up"
                            v-if="sort_order == 'asc'"
                            style="font-size: 12px"></v-icon>
                  </a>
                </template>
              </th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item, index) in dataTable" :key="item.id">
              <td align="center">{{((dataPaginate.current_page-1)*10)+(index+1)}}</td>
              <td>{{ item.branch ? item.branch.branch_name_th : "" }}</td>
              <td>{{item.detail_th}}</td>
              <td>{{item.detail_en}}</td>
              <td>
                {{ item.one_day_pass_th }}
              </td>
              <td>{{ item.annual_fee_th }}</td>
              <td>{{ item.updated_at | moment("DD-MM-YYYY") }}</td>
              <td>{{ item.orders }}</td>
              <td>
                <a @click="showMembershipRate(item.id)">
                  <icon-pencil />
                </a>
              </td>
            </tr>
          </tbody>
        </template>
      </v-simple-table>
    </template>
    <paginate :length="dataPaginate.last_page"
              :page="dataPaginate.current_page"
              @update="changePage">
    </paginate>
  </div>
</template>

<script>
import InputTextField from "../../../components/Input/InputTextField";
import IconPencil from "../../../components/Icon/icon-pencil";
import CircleButton from "../../../components/Button/CircleButton";
import InputSearch from "../../../components/Input/InputSearch";
import Paginate from "../../../components/Layout/Paginate";
import {permissionMembershipRate, role} from "../../../util/Permission";
import {mapState} from "vuex";
import Loading from 'vue-loading-overlay';
export default {
  name: "MembershipRateTable",
  components: {Paginate, InputSearch, CircleButton, IconPencil, InputTextField, Loading },
  data() {
    return {
      title: "Membership rate",
      isLoading: false,
      headers: [
        { id: 1, text: "No." ,icon : null},
        { id: 2, text: "Branch" ,icon : null},
        { id: 3, text: "Description EN" ,icon : null},
        { id: 4, text: "Description TH" ,icon : null},
        { id: 5, text: "One day pass" ,icon : null},
        { id: 6, text: "Annual fee" ,icon : null},
        { id: 7, text: "Update date" ,icon : null},
        { id: 8, text: "Order" ,icon : true},
        { id: 9, text: "edit" ,icon : null}
      ],
      dataTable: [],
      dataPaginate: {
        current_page: 1,
        from: 1,
        last_page: 1,
        per_page: 1,
        total: 1,
        to: 1
      },
      permission : null,
      search : '',
      sort_order : 'desc',
    };
  },
  created() {
    this.permission = role;
    this.getMembershipRateTable(1);
  },
  computed: {
    permissionMembershipRate,
  },
  methods: {
    goToMembershipRateEdit() {
      this.$router.push("/membership-rate/edit");
    },
    getMembershipRateTable(page) {
      this.isLoading = true;
      this.$store.dispatch("MembershipRate/getMembershipRate", {
        page,
        search : this.search,
        sort_order : this.sort_order,
      }).then(res => {
        if (res.response_code === 200) {
          this.dataTable = res.result.data;
        } else {
          Swal(res.response_msg);
        }
        this.isLoading = false;
      });
    },
    async changePage(val){
      this.isLoading = true;
      this.dataPaginate.current_page = val;
      await this.getMembershipRateTable(this.dataPaginate.current_page);
      this.isLoading = false;
    },
    createMembershipRate() {
      this.$store.dispatch("MembershipRate/clearFormDataMembershipRate").then(() => {
        this.goToMembershipRateEdit();
      });
    },
    showMembershipRate(id) {
      this.isLoading = true;
      this.$store.dispatch("MembershipRate/showMembershipRate", id).then(res => {
        if (res.response_code == 200) {
          this.$store.dispatch("MembershipRate/setFormMembershipRate", res.result).then(() => {
            this.goToMembershipRateEdit();
          });
        } else {
          Swal(res.response_msg);
        }
        this.isLoading = false;
      });
    },
    searchInput(val){
      this.search = val;
    },
    sortDataTable(){
      this.sort_order = this.sort_order == 'desc' ? 'asc' : 'desc';
      this.getMembershipRateTable(1);
    }
  }
};
</script>

<style lang="scss" scoped>
@import "../../../assets/css/table.css";
@import "../../../assets/css/variables";
.branch-data {
  background-color: transparent;
  margin: 20px;
}
.theme--light.v-system-bar {
  background-color: transparent !important;
  color: rgba(0, 0, 0, 0.6);
}
</style>
